import { ImageWrapper } from '../../common/wrappers/ImageWrapper';
import React, { useEffect } from 'react';
import map1 from '../../../assets/images/games/zdar-kids-game/map/1_stanoviste_u_mostu.webp';
import map10 from '../../../assets/images/games/zdar-kids-game/map/11_u_stojanu_na_kola.webp';
import map11 from '../../../assets/images/games/zdar-kids-game/map/12_zase_u_stojanu_na_kola.webp';
import map12 from '../../../assets/images/games/zdar-kids-game/map/13_strom.webp';
import map13 from '../../../assets/images/games/zdar-kids-game/map/14_hriste.webp';
import map2 from '../../../assets/images/games/zdar-kids-game/map/3_pod_schody.webp';
import map3 from '../../../assets/images/games/zdar-kids-game/map/4_rozcesti.webp';
import map4 from '../../../assets/images/games/zdar-kids-game/map/5_lavicka_na_ceste.webp';
import map5 from '../../../assets/images/games/zdar-kids-game/map/6_znacka.webp';
import map6 from '../../../assets/images/games/zdar-kids-game/map/7_zastavka.webp';
import map7 from '../../../assets/images/games/zdar-kids-game/map/8_mostek_1.webp';
import map8 from '../../../assets/images/games/zdar-kids-game/map/9_mostek_2.webp';
import map9 from '../../../assets/images/games/zdar-kids-game/map/10_u_cedule_u_kostela.webp';

type Props = {
    currentStep: number;
};

export default function ZdarKidsMap({ currentStep }: Props) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const getMap = () => {
        if (currentStep <= 3) {
            return map1;
        } else if (currentStep <= 5) {
            return map2;
        } else if (currentStep <= 7) {
            return map3;
        } else if (currentStep <= 9) {
            return map4;
        } else if (currentStep <= 11) {
            return map5;
        } else if (currentStep <= 18) {
            return map6;
        } else if (currentStep <= 21) {
            return map7;
        } else if (currentStep <= 23) {
            return map8;
        } else if (currentStep <= 28) {
            return map9;
        } else if (currentStep <= 29) {
            return map10;
        } else if (currentStep <= 31) {
            return map11;
        } else if (currentStep <= 33) {
            return map12;
        } else {
            return map13;
        }
    };

    return (
        <React.Fragment>
            <div className="zdar-kids-map">
                <div className="task-title">
                    <div className="task-title-text">Mapa trasy</div>
                </div>
                <ImageWrapper src={getMap()} alt="mapa" allowLightbox={false} />
            </div>
        </React.Fragment>
    );
}
